import React from 'react';

import type {
  Subscription,
  SubscriptionChangePreview,
} from '@repo/subscription/api';
import { Spacer } from '@repo/ui/components/Spacer';
import { P4, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { Divider } from '../../utilities/styles';
import usePaymentInfoPlanSection from '../hooks/usePaymentInfoPlanSection';

import { TableRow } from './styles';

const PlanSection: React.FC<{
  currentSubscription: Subscription | null;
  changeSubscriptionPreview?: SubscriptionChangePreview | null;
}> = ({ currentSubscription, changeSubscriptionPreview }) => {
  const sections = usePaymentInfoPlanSection({
    currentSubscription,
    changeSubscriptionPreview,
  });

  return (
    <>
      <P4 color={themeStyle.varInkMedium}>Plan Type</P4>
      <Spacer height="4px" />
      {sections.map((section) => (
        <TableRow key={section.leftText}>
          <P3>{section.leftText}</P3>
          {section.rightText && (
            <P3 style={{ textAlign: 'right' }}>{section.rightText}</P3>
          )}
        </TableRow>
      ))}
      <Divider style={{ margin: '12px 0' }} />
    </>
  );
};

export default PlanSection;
